import React from 'react'
import { string } from 'prop-types'
import styled from 'styled-components'
import { stripUnit } from 'polished'
// import LazyLoad from 'react-lazyload'
import { Link } from 'gatsby'

import * as spacing from 'styles/spacing'
import { media } from 'styles/media'
import { white } from 'styles/colors'
import { Lead } from 'styles/typography'
import { borderRadius, cover } from 'styles/global'

const Container = styled(Link)`
  position: relative;
  display: block;
  width: 100%;
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
`

const FigureWrap = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  border-radius: ${stripUnit(borderRadius) * 2 + 'px'};
  width: 100%;
  overflow: hidden;
  margin-bottom: ${spacing.medium};

  &:after {
    content: '';
    display: block;
    padding-bottom: 65%;
    width: 100%;
  }

  ${media.medium`
    align-items: center;
  `};

  ${media.large`
    margin-bottom: ${spacing.large};
  `};
`

const Label = styled(Lead)`
  color: ${white};
  letter-spacing: 0.2em;
  text-align: center;
`

const Figure = styled.img`
  ${cover('absolute')};
  transform: none;
  object-fit: cover;
  border-radius: 0;
  backface-visibility: hidden;
`

const HomeOffer = ({ label, link, figure }) => (
  <Container to={link}>
    <FigureWrap>
      <Figure src={`${process.env.BASE_PATH}/images/${figure}`} alt={label} />
    </FigureWrap>
    <Label>{label}</Label>
  </Container>
)

HomeOffer.propTypes = {
  label: string.isRequired,
  figure: string.isRequired,
  link: string.isRequired
}

export default HomeOffer
